export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.amerinotipico.it";
export const TOKEN_KEY = "strapi-jwt-token";
